import useMediaQuery from '@mui/material/useMediaQuery';
export default useMediaQuery;
export * from '@mui/material/useMediaQuery';
